'use client'

import React, { useEffect, useState } from 'react'
import Link from 'next/link'
// import { Link, useLocation } from 'react-router-dom'
import { usePathname } from 'next/navigation'
import api from '../lib/api.interceptor'
import { Toast } from './forms/Toast'

const Footer = ({ adminDetail, socialList, pageList, propertylist }) => {
  const pathName = usePathname()

  const [categoryList, setCategoryList] = useState([])
  const [categoryList2, setCategoryList2] = useState([])
  const [isMobileScreen, setMobileScreen] = useState(false)
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [year, setYear] = useState('2025')
  const [activeSection, setActiveSection] = useState(null)
  const [activeCategory, setActiveCategory] = useState(null)

  const toggleCategory = (category) => {
    setActiveCategory((prev) => (prev === category ? null : category))
    setActiveSection(null)
  }

  const handleAccordionToggle = (sectionId) => {
    setActiveSection((prev) => (prev === sectionId ? null : sectionId))
    setActiveCategory(null)
  }

  function closeAccordion() {
    setActiveCategory(null)
    setActiveSection(null)
  }

  useEffect(() => {
    if (window.innerWidth <= 767) {
      setMobileScreen(true)
    }

    if (Array.isArray(propertylist)) {
      getCategory()
    }
  }, [])

  async function getCategory() {
    try {
      const categorySet = new Set()
      const categoryArray = []

      propertylist.forEach((value) => {
        if (!categorySet.has(value.category)) {
          categoryArray.push({ category: value.category })
          categorySet.add(value.category)
        }
      })

      // console.log(categoryArray);

      setCategoryList(categoryArray)
      // categoryArray.push({ category: "Leasing" });
      setCategoryList2([...categoryArray, { category: 'Leasing' }])
    } catch (error) {
      console.error('Error fetching property details:', error)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!email || !emailRegex.test(email)) {
      setEmailError(true)
      return
    }

    setEmailError(false)
    setIsSubmitting(true)

    try {
      // console.log('Subscribed with:', email)
      setEmail('')
      const inqObj = {}
      inqObj.addsubscribe = true
      inqObj.logged_in_master_user_id = 239
      inqObj.master_user_id = 239
      inqObj.email_address = email

      // console.log(inqObj)

      const response = await api.FooterEmail(inqObj)
      if (response.success == 1) {
        setIsSubmitting(false)
        setErrors({})
        // navigate(`/contact-us/thank_you`, {
        //   state: {
        //     page_name: 'Contact Us',
        //     document: []
        //   }
        // })

        // dispatch(setThankYouData({ page_name: 'Contact Us', document: [] }))
        // router.push('/contact-us/thankyou')

        Toast(response.message)
        setFormData({
          name: '',
          contact_no_display: '',
          contact_no: '',
          email: '',
          from_app: 'true',
          master_user_id: '373',
          logged_in_master_user_id: '373',
          department: '',
          message: '',
          flag: 'https://flagcdn.com/w40/in.webp',
          country: '91'
        })
      } else {
        setIsSubmitting(false)
        Toast(response.message)
      }
    } catch (error) {
      console.error('Subscription failed', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <div className="reecosys-footer" id="reecosys-footer">
        <div className="reecosys-footer-content">
          {/* ng-if="!isMobilescreen" */}
          {!isMobileScreen && (
            <div className="reecosys_footer_web">
              <div className="web_footer_content">
                <div className="footer-info-logo-div">
                  <div className="reecosys-brand-logo-footer">
                    <Link
                      href="/"
                      title={adminDetail.name}
                      className="touch-target"
                    >
                      {/* ng-if="adminDetail.logo != ''" */}
                      {adminDetail.logo != '' && (
                        <div>
                          <img src={adminDetail.logo} alt="" />
                        </div>
                      )}
                      {/* ng-if="adminDetail.logo == ''" */}
                      {adminDetail.logo == '' && (
                        <div className="footer_logo_text">
                          <p className="capitalize">{adminDetail.name}</p>
                        </div>
                      )}
                    </Link>
                  </div>
                  <br />
                  <div className="flex-row-footer">
                    <div className="flex-icon-footer">
                      <img src="/images/footer/call2.svg" alt="" />
                    </div>
                    <div>
                      <Link href="tel:+91-74520-74520">
                        <p>+91-7452074520</p>
                      </Link>
                    </div>
                  </div>
                  <div className="flex-row-footer">
                    <div className="flex-icon-footer">
                      <img src="/images/footer/email2.svg" alt="" />
                    </div>
                    <div>
                      <Link href="mailto:coordination@venusinfrastructure.com">
                        <p style={{ textTransform: 'lowercase !important' }}>
                          coordination@venusinfrastructure.com
                        </p>
                      </Link>
                    </div>
                  </div>
                  <div className="flex-row-footer">
                    <div className="flex-icon-footer">
                      <img src="/images/footer/location2.svg" alt="" />
                    </div>
                    <div>
                      <Link
                        href="https://maps.app.goo.gl/mfcEnsodG79vGSgS8"
                        target="_blank"
                      >
                        <p>
                          1101, Venus Amadeus, Jodhpur Cross Road, Satellite,
                          Ahmedabad
                        </p>
                      </Link>
                    </div>
                  </div>
                  <br />
                  <ul className="social_media_list">
                    {/*ng-repeat="data in project_social_links" */}
                    {socialList &&
                      socialList.length > 0 &&
                      socialList.map((data, i) => {
                        return (
                          <li key={i}>
                            {data.name == 'facebook' && (
                              <div>
                                <a
                                  href={data.slug}
                                  target="_blank"
                                  title="Venus Group facebook"
                                  aria-label="Venus Group facebook"
                                >
                                  <img
                                    src="/images/social/facebook.png"
                                    alt="Venus Group facebook"
                                    className="social-media-icon-footer"
                                  />
                                </a>
                              </div>
                            )}
                            {data.name == 'instagram' && (
                              <div>
                                <a
                                  href={data.slug}
                                  target="_blank"
                                  title="Venus Group instagram"
                                  aria-label="Venus Group instagram"
                                >
                                  <img
                                    src="/images/social/instagram.png"
                                    alt="Venus Group instagram"
                                    className="social-media-icon-footer"
                                  />
                                </a>
                              </div>
                            )}
                            {data.name == 'twitter' && (
                              <div>
                                <a
                                  href={data.slug}
                                  target="_blank"
                                  title="Venus Group twitter"
                                  aria-label="Venus Group twitter"
                                >
                                  <img
                                    src="/images/social/twitter.png"
                                    alt="Venus Group twitter"
                                    className="social-media-icon-footer"
                                  />
                                </a>
                              </div>
                            )}
                            {data.name == 'linkedin' && (
                              <div>
                                <a
                                  href={data.slug}
                                  target="_blank"
                                  title="Venus Group indeed"
                                  aria-label="Venus Group indeed"
                                >
                                  <img
                                    src="/images/social/indeed.png"
                                    alt="Venus Group indeed"
                                    className="social-media-icon-footer"
                                  />
                                </a>
                              </div>
                            )}
                            {data.name == 'youtube' && (
                              <div>
                                <a
                                  href={data.slug}
                                  target="_blank"
                                  title="Venus Group youtube"
                                  aria-label="Venus Group youtube"
                                >
                                  <img
                                    src="/images/social/youtube.png"
                                    alt="Venus Group youtube"
                                    className="social-media-icon-footer"
                                  />
                                </a>
                              </div>
                            )}
                          </li>
                        )
                      })}
                  </ul>
                  <br />
                  <div className="section-information subscribe_btn_section">
                    <form
                      id="subscribe"
                      name="subscribe"
                      onSubmit={handleSubmit}
                      autoComplete="off"
                    >
                      <div className="subscribe_inner_flex">
                        <div className="contact_lable subscribe_lable">
                          <input
                            id="email_address"
                            name="email_address"
                            type="email"
                            placeholder="Enter Your Email Address"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value)
                              setEmailError(false)
                            }}
                            // required
                            className={`form-control ${
                              emailError ? 'error' : ''
                            }`}
                            autoComplete="off"
                          />
                          <label className="md-lable" htmlFor="email_address">
                            Subscribe for more updates
                          </label>
                        </div>

                        <div className="button-div filled-div-button wfc">
                          <button
                            className="button-style red-btn"
                            disabled={isSubmitting}
                            aria-label="Subscribe"
                            type="submit"
                          >
                            <p>{isSubmitting ? 'Please wait..' : 'Submit'}</p>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="">
                  {/* ng-if="page_full_list.length > 0 || venture_full_list.length > 0" */}
                  {pageList && pageList.length > 0 && (
                    // || venture_full_list.length > 0 &&
                    <div className="project_other_links">
                      <p className="project_links_title">Company</p>
                      <ul>
                        <li>
                          <Link
                            href="/about-us"
                            className={`capitalize ${
                              pathName == '/about-us' ? 'active_page' : ''
                            }`}
                          >
                            <p className="capitalize">About Us</p>
                          </Link>
                        </li>
                        <li>
                          <Link
                            href="/awards"
                            className={`capitalize ${
                              pathName == '/awards' ? 'active_page' : ''
                            }`}
                          >
                            <p className="capitalize">Awards</p>
                          </Link>
                        </li>
                        <li>
                          <Link
                            href="/leadership"
                            className={`capitalize ${
                              pathName == '/leadership' ? 'active_page' : ''
                            }`}
                          >
                            <p className="capitalize">Leadership</p>
                          </Link>
                        </li>
                        <li>
                          <Link
                            href="/news"
                            className={`capitalize ${
                              pathName == '/news' ? 'active_page' : ''
                            }`}
                          >
                            <p className="capitalize">News & Events</p>
                          </Link>
                        </li>
                        <li>
                          <Link
                            href="/media"
                            className={`capitalize ${
                              pathName == '/media' ? 'active_page' : ''
                            }`}
                          >
                            <p className="capitalize">Media</p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                  <div className="inner-flex">
                    {/* ng-repeat="category_data in projects_category" */}
                    {/* ng-if="category_data.category" */}
                    {/* {JSON.stringify(categoryList)} */}
                    {Array.isArray(categoryList) &&
                      categoryList.map((category_data, i) => {
                        // console.log("category_data:", category_data);
                        return (
                          category_data && (
                            <div className="project_other_links" key={i}>
                              <p
                                onClick={() => {
                                  redirectTo('/projects')
                                }}
                                className="project_links_title"
                                style={{ cursor: 'pointer' }}
                              >
                                {category_data.category}
                              </p>
                              <ul>
                                {/* ng-repeat="data in projects_full_list" */}
                                {propertylist &&
                                  propertylist.length > 0 &&
                                  propertylist.map((data, ind) => {
                                    // console.log(
                                    //   "Project category:",
                                    //   data.category
                                    // );
                                    return (
                                      // ng-if="data.category == category_data.category && data.project_id != 621"
                                      data &&
                                      data.category == category_data.category &&
                                      data.project_id != 621 && (
                                        <li key={ind}>
                                          <Link
                                            href={`/${data.slug}`}
                                            className={
                                              pathName == `/${data.slug}`
                                                ? 'active_page'
                                                : ''
                                            }
                                          >
                                            <p className="capitalize">
                                              {data.project_title}
                                            </p>
                                          </Link>
                                        </li>
                                      )
                                    )
                                  })}
                              </ul>
                            </div>
                          )
                        )
                      })}
                    <div className="project_other_links">
                      <p
                        onClick={() => {
                          redirectTo('/projects')
                        }}
                        className="project_links_title"
                        style={{ cursor: 'pointer' }}
                      >
                        Leasing
                      </p>
                      <ul>
                        {/* ng-repeat="data in projects_full_list" */}
                        {propertylist &&
                          propertylist.length > 0 &&
                          propertylist.map((data, i) => {
                            return (
                              // ng-if="data.project_id == 621"
                              data.project_id == 621 && (
                                <li key={i}>
                                  <Link
                                    href={`/${data.slug}`}
                                    className={
                                      pathName == `/${data.slug}`
                                        ? 'active_page'
                                        : ''
                                    }
                                  >
                                    <p className="capitalize">
                                      {data.project_title}
                                    </p>
                                  </Link>
                                </li>
                              )
                            )
                          })}
                      </ul>
                    </div>
                  </div>
                  <div className="inner-flex">
                    {/* ng-if="page_full_list.length > 0 || venture_full_list.length > 0" */}
                    {pageList && pageList.length > 0 && (
                      <div className="project_other_links">
                        <p className="project_links_title">Quick Links</p>
                        <ul>
                          <li>
                            <Link
                              href="/channelpartner"
                              className={`capitalize ${
                                pathName == '/channelpartner'
                                  ? 'active_page'
                                  : ''
                              }`}
                            >
                              <p className="capitalize">
                                Channel Partner Program
                              </p>
                            </Link>
                          </li>
                          {/* ng-repeat="data in page_full_list" */}
                          {/* ng-if="data.page_type == '' && data.is_profile_page == 0 && data.slug !='about-us' && data.slug !='vendor' && data.slug !='channelpartner'" */}
                          {pageList &&
                            pageList.length > 0 &&
                            pageList.map((data, i) => {
                              return (
                                data.page_type == '' &&
                                data.is_profile_page == 0 &&
                                data.slug != 'about-us' &&
                                data.slug != 'vendor' &&
                                data.slug != 'channelpartner' && (
                                  <li key={i}>
                                    <Link
                                      href={`/${data.slug}`}
                                      className={
                                        pathName == `/${data.slug}`
                                          ? 'active_page'
                                          : ''
                                      }
                                      target={data.slug_target}
                                    >
                                      <p className="capitalize">
                                        {data.page_name}
                                      </p>
                                    </Link>
                                  </li>
                                )
                              )
                            })}
                          <li>
                            <Link
                              href="/plotted-development"
                              className={`capitalize ${
                                pathName == `/plotted-development`
                                  ? 'active_page'
                                  : ''
                              }`}
                            >
                              <p className="capitalize">Plotted Development</p>
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/completed-projects"
                              className={`capitalize ${
                                pathName == `/completed-projects`
                                  ? 'active_page'
                                  : ''
                              }`}
                            >
                              <p className="capitalize">Completed Projects</p>
                            </Link>
                          </li>
                          {/* venture_full_list */}
                          {/* <li ng-repeat="data in venture_full_list">
                            <a href="{{data.slug}}" className="capitalize">
                              <p className="capitalize">{data.page_name}</p>
                            </a>
                          </li> */}

                          {/* <!-- <li ng-if="$storage.permissions.indexOf('blogs') != -1">
                                          <a href="blogs" className="capitalize " ng-className="{'active_page': activePath == '/blogs/'}">
                                              <p className="capitalize">Blogs</p>
                                          </a>
                                      </li> --> */}
                        </ul>
                      </div>
                    )}
                    <div className="project_other_links">
                      <p className="project_links_title">Download App</p>
                      <div className="flex-row">
                        <a
                          href="https://play.google.com/store/apps/details?id=com.coronation.venus"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Download Venus Infrastructure on the Play Store"
                          aria-label="Download Venus Infrastructure on the Play Store"
                        >
                          <img
                            src="/images/play-store.svg"
                            alt="Download Venus Infrastructure on the Play Store"
                          />
                        </a>
                        <a
                          href="https://apps.apple.com/us/app/venus-infrastructure/id6737413423"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Download Venus Infrastructure on the App Store"
                          aria-label="Download Venus Infrastructure on the App Store"
                        >
                          <img
                            src="/images/app-store.svg"
                            alt="Download Venus Infrastructure on the App Store"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="reecosys_footer_copyright">
                <div>
                  <div className="web_copyright">
                    <p className="p0">
                      &copy; {adminDetail.name} {year} - All Rights Reserved.
                    </p>
                  </div>
                </div>
                <div className="footer_legals text-center">
                  <ul>
                    {/* <!-- <li ng-repeat="data in page_full_list" ng-if="data.page_type == 'legal'">
                                        <a href="{{data.slug}}">
                                            <p className="capitalize">{{data.page_name}}</p>
                                        </a>
                                    </li> --> */}
                    <li>
                      <p className="capitalize">
                        <Link href="/disclaimer"> Disclaimer </Link> &nbsp; /
                        &nbsp;
                        <Link href="/privacy-policy"> Privacy Policy </Link>
                      </p>
                    </li>
                    {/* <!-- <li>
                                        <a href="javascript:void(0);">
                                            <p className="capitalize">Compliance</p>
                                        </a>
                                    </li> --> */}
                  </ul>
                </div>
                <div>
                  <div className="powered-by text-right">
                    <p>Powered By :</p>
                    <Link href="https://www.reecosys.com/" target="_blank">
                      <p className="">REECOSYS</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isMobileScreen && (
            <div className="reecosys-footer-link-sections reecosys-mainfooter-section-links">
              <div className="mob-link" style={{ margin: '0 !important' }}>
                <div className="logo-social-flex-mobile">
                  <div className="reecosys-brand-logo-footer">
                    <Link href="/" title={adminDetail.name}>
                      {/* ng-if="adminDetail.logo != ''" */}
                      {adminDetail.logo != '' && (
                        <div>
                          <img src={adminDetail.logo} alt="" />
                        </div>
                      )}
                      {/* ng-if="adminDetail.logo == ''" */}
                      {adminDetail.logo == '' && (
                        <div className="footer_logo_text">
                          <p className="capitalize">{adminDetail.name}</p>
                        </div>
                      )}
                    </Link>
                  </div>
                  {/* ng-if="project_social_links.length > 0" */}
                  {socialList && socialList.length > 0 && (
                    <div>
                      <ul className="social_media_list">
                        {/* <li ng-repeat="data in project_social_links"> */}
                        {socialList.map((data, i) => {
                          return (
                            <li key={i}>
                              {data.name == 'facebook' && (
                                <div>
                                  <a
                                    href={`${data.slug}`}
                                    target="_blank"
                                    title="Venus Group facebook"
                                    aria-label="Venus Group facebook"
                                  >
                                    <img
                                      src="/images/social/facebook.png"
                                      alt="Venus Group facebook"
                                      className="social-media-icon-footer"
                                    />
                                  </a>
                                </div>
                              )}
                              {data.name == 'instagram' && (
                                <div>
                                  <a
                                    href={`${data.slug}`}
                                    target="_blank"
                                    title="Venus Group instagram"
                                    aria-label="Venus Group instagram"
                                  >
                                    <img
                                      src="/images/social/instagram.png"
                                      alt="Venus Group instagram"
                                      className="social-media-icon-footer"
                                    />
                                  </a>
                                </div>
                              )}
                              {data.name == 'twitter' && (
                                <div>
                                  <a
                                    href={`${data.slug}`}
                                    target="_blank"
                                    title="Venus Group twitter"
                                    aria-label="Venus Group twitter"
                                  >
                                    <img
                                      src="/images/social/twitter.png"
                                      alt="Venus Group twitter"
                                      className="social-media-icon-footer"
                                    />
                                  </a>
                                </div>
                              )}
                              {data.name == 'linkedin' && (
                                <div>
                                  <a
                                    href={`${data.slug}`}
                                    target="_blank"
                                    title="Venus Group indeed"
                                    aria-label="Venus Group indeed"
                                  >
                                    <img
                                      src="/images/social/indeed.png"
                                      alt="Venus Group indeed"
                                      className="social-media-icon-footer"
                                    />
                                  </a>
                                </div>
                              )}
                              {data.name == 'youtube' && (
                                <div>
                                  <a
                                    href={`${data.slug}`}
                                    target="_blank"
                                    title="Venus Group youtube"
                                    aria-label="Venus Group youtube"
                                  >
                                    <img
                                      src="/images/social/youtube.png"
                                      alt="Venus Group youtube"
                                      className="social-media-icon-footer"
                                    />
                                  </a>
                                </div>
                              )}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="section-information subscribe_btn_section">
                  <form
                    id="subscribe"
                    name="subscribe"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <div className="subscribe_inner_flex">
                      <div className="contact_lable subscribe_lable">
                        <input
                          id="email_address"
                          name="email_address"
                          type="email"
                          placeholder="Enter Your Email Address"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value)
                            setEmailError(false)
                          }}
                          className={`form-control ${
                            emailError ? 'error' : ''
                          }`}
                          autoComplete="off"
                        />
                        <label className="md-lable" htmlFor="email_address">
                          Subscribe for more updates
                        </label>
                      </div>

                      <div className="button-div filled-div-button wfc">
                        <button
                          className="button-style red-btn"
                          disabled={isSubmitting}
                          aria-label="Subscribe"
                          type="submit"
                        >
                          <p>{isSubmitting ? 'Please wait..' : 'Submit'}</p>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <ul className="quicklinks-footer quicklinks-footer-mobile">
                  <li>
                    <Link href="/">
                      <p className="capitalize">Home</p>
                    </Link>
                  </li>
                  <li className="project-footer-accordion">
                    <div
                      onClick={() =>
                        handleAccordionToggle('abouts-us-drop-footer')
                      }
                      className={
                        activeSection === 'abouts-us-drop-footer'
                          ? 'active'
                          : ''
                      }
                    >
                      <div className="a">
                        <p className="capitalize">About</p>
                        <span className="down_arrow_footer">
                          <img
                            src="/images/icon/add-acc.svg"
                            className="footer-acc-plus"
                            alt=""
                          />
                          <img
                            src="/images/icon/remove-acc.png"
                            className="footer-acc-remove"
                            alt=""
                          />
                        </span>
                      </div>
                    </div>

                    <div
                      className={`project-links content_accordian ${
                        activeSection === 'abouts-us-drop-footer'
                          ? 'active_list'
                          : ''
                      }`}
                    >
                      <ul>
                        {[
                          { name: 'About Us', path: '/about-us' },
                          { name: 'Awards', path: '/awards' },
                          { name: 'Leadership', path: '/leadership' },
                          { name: 'News & Events', path: '/news' },
                          { name: 'Media', path: '/media' }
                        ].map((item, idx) => (
                          <li key={idx}>
                            <p className="capitalize">
                              <Link
                                href={item.path}
                                className={
                                  location.pathname === item.path
                                    ? 'active_page'
                                    : ''
                                }
                                onClick={() => {
                                  // Optional: close menus if needed
                                  // closeNavAccordion();
                                  // closeMenu();
                                  closeAccordion()
                                }}
                              >
                                {item.name}
                              </Link>
                            </p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                  {/* ng-repeat="category in projects_category" */}
                  {categoryList2 &&
                    categoryList2.length > 0 &&
                    categoryList2.map((category, i) => (
                      <li className="project-footer-accordion" key={i}>
                        <div
                          onClick={() => toggleCategory(category.category)}
                          className={
                            activeCategory === category.category ? 'active' : ''
                          }
                        >
                          <div className="a">
                            <p className="capitalize">{category.category}</p>
                            <span className="down_arrow_footer">
                              <img
                                src="/images/icon/add-acc.svg"
                                className="footer-acc-plus"
                                alt=""
                              />
                              <img
                                src="/images/icon/remove-acc.png"
                                className="footer-acc-remove"
                                alt=""
                              />
                            </span>
                          </div>
                        </div>
                        <div
                          className={`project-links content_accordian ${
                            activeCategory === category.category
                              ? 'active_list'
                              : ''
                          }`}
                        >
                          <ul>
                            {propertylist
                              .filter((data) =>
                                // data.category === category.category &&
                                // data.project_id !== 621
                                {
                                  if (data.category === category.category) {
                                    return data.project_id !== 621
                                  } else if (category.category === 'Leasing') {
                                    return data.project_id == 621
                                  }
                                  return false
                                }
                              )
                              .map((data, i) => (
                                <li className="links-flex-column" key={i}>
                                  <Link
                                    href={`/${data.slug}`} // or `/${data.slug}` depending on routing
                                    onClick={() => {
                                      // navAccordionClose();
                                      // menuClickClose();
                                      closeAccordion()
                                    }}
                                  >
                                    <div className="dropdown_project_list">
                                      <div className="header_project_thum border-radius-web relative">
                                        {data.banner_data?.image_web_full && (
                                          <>
                                            {data.banner_data.image_web_type ===
                                            'image' ? (
                                              <img
                                                src={`${data.banner_data.image_web_full}&h=300&w=300`}
                                                alt="reecosys"
                                              />
                                            ) : (
                                              <video
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                id="myVideo"
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                  display: 'block',
                                                  objectFit: 'cover'
                                                }}
                                              >
                                                <source
                                                  src={
                                                    data.banner_data
                                                      .image_web_full
                                                  }
                                                  type="video/mp4"
                                                />
                                              </video>
                                            )}
                                          </>
                                        )}
                                      </div>

                                      <div className="dropdown_project_content">
                                        {data.project_title && (
                                          <div className="dropdown_project_title">
                                            <h4 className="capitalize">
                                              {data.project_title}
                                            </h4>
                                          </div>
                                        )}

                                        <div className="dropdown_project_info_list">
                                          {data.size_price && (
                                            <div className="dropdown_project_info">
                                              <div className="dropdown_project_img">
                                                <img
                                                  src="/images/icon/building.png"
                                                  alt=""
                                                />
                                              </div>
                                              <div className="capitalize mt4">
                                                <p>{data.size_price}</p>
                                              </div>
                                            </div>
                                          )}

                                          {data.location && (
                                            <div className="dropdown_project_info">
                                              <div className="dropdown_project_img">
                                                <img
                                                  src="/images/icon/location.png"
                                                  alt=""
                                                />
                                              </div>
                                              <div className="capitalize mt2">
                                                <p>{data.location}</p>
                                              </div>
                                            </div>
                                          )}

                                          {data.construction && (
                                            <div className="dropdown_project_status dropdown_project_info">
                                              <div className="progress-statuss">
                                                {data.construction
                                                  .progress_percent > 0 ? (
                                                  <div
                                                    className="progress"
                                                    data-percentage={
                                                      data.construction
                                                        .progress_percent
                                                    }
                                                  >
                                                    <span className="progress-left">
                                                      <span className="progress-bar"></span>
                                                    </span>
                                                    <span className="progress-right">
                                                      <span className="progress-bar"></span>
                                                    </span>
                                                    <div className="progress-value value_get">
                                                      <p>
                                                        {
                                                          data.construction
                                                            .progress_percent
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="progress-consctruction progress_banner">
                                                    <img
                                                      src="/images/icon/construction.png"
                                                      alt=""
                                                    />
                                                  </div>
                                                )}
                                              </div>

                                              {data.status && (
                                                <div className="capitalize">
                                                  <p>
                                                    {data.status ===
                                                    'under construction'
                                                      ? 'Ongoing'
                                                      : data.status}
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </li>
                    ))}
                  <li>
                    <Link
                      href="/completed-projects"
                      className={`capitalize ${
                        pathName == '/completed-projects' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Completed Projects</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/channelpartner"
                      className={`capitalize ${
                        pathName == '/channelpartner' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Channel Partner Program</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/vendor"
                      className={`capitalize ${
                        pathName == '/vendor' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Vendor</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/redevelopment"
                      className={`capitalize ${
                        pathName == '/redevelopment' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Redevelopment</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/career"
                      className={`capitalize ${
                        pathName == '/career' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Career</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/contact-us"
                      className={`capitalize ${
                        pathName == '/contact-us' ? 'active_page' : ''
                      }`}
                    >
                      <p className="capitalize">Contact</p>
                    </Link>
                  </li>
                  <li>
                    <p className="capitalize">Download App</p>
                    <div
                      className="flex-row"
                      style={{ paddingTop: '1rem', width: '75%' }}
                    >
                      <a
                        href="https://play.google.com/store/apps/details?id=com.coronation.venus"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Download Venus Infrastructure on the Play Store"
                        aria-label="Download Venus Infrastructure on the Play Store"
                      >
                        <img
                          src="/images/play-store.svg"
                          alt="Download Venus Infrastructure on the Play Store"
                        />
                      </a>
                      <a
                        href="https://apps.apple.com/us/app/venus-infrastructure/id6737413423"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Download Venus Infrastructure on the App Store"
                        aria-label="Download Venus Infrastructure on the App Store"
                      >
                        <img
                          src="/images/app-store.svg"
                          alt="Download Venus Infrastructure on the App Store"
                          width="140"
                          height="40"
                        />
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="reecosys_footer_copyright">
                <div>
                  <div className="web_copyright">
                    <p className="p0">
                      &copy; {adminDetail.name} {year} - All Rights Reserved.
                    </p>
                  </div>
                </div>
                <div className="footer_legals">
                  <ul>
                    {/* <!-- <li ng-repeat="data in page_full_list" ng-if="data.page_type == 'legal'">
                                      <a href="{{data.slug}}">
                                          <p className="capitalize">{{data.page_name}}</p>
                                      </a>
                                  </li> --> */}
                    <li>
                      <p className="capitalize">
                        <Link href="/disclaimer"> Disclaimer </Link> &nbsp; /
                        &nbsp;
                        <Link href="/privacy-policy"> Privacy Policy </Link>
                      </p>
                    </li>
                    {/* <!-- <li>
                                      <a href="javascript:void(0);">
                                          <p className="capitalize">Compliance</p>
                                      </a>
                                  </li> --> */}
                  </ul>
                </div>
                <div>
                  <div className="powered-by">
                    <p>Powered By :</p>
                    <Link
                      href="https://www.reecosys.com/"
                      target="_blank"
                      title="REECOSYS"
                      aria-label="REECOSYS"
                    >
                      <p className="">REECOSYS</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Footer
